import { Users, Layers } from 'lucide-react';
import type { GroupMode } from '@/types/timeline';

export interface GroupModeToggleProps {
  /** Currently selected group mode */
  value: GroupMode;
  /** Callback when selection changes */
  onChange: (mode: GroupMode) => void;
  /** Optional additional className */
  className?: string;
}

/**
 * Group mode toggle molecule - toggle between team and feature grouping
 *
 * Provides a button group for switching between different grouping modes
 * in the timeline visualization.
 */
export function GroupModeToggle({ value, onChange, className = '' }: GroupModeToggleProps) {
  return (
    <div
      className={`
        flex items-center gap-2 rounded-lg bg-bg-muted p-1
        ${className}
      `}
    >
      <button
        onClick={() => onChange('team')}
        className={`
          flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors
          ${
            value === 'team'
              ? 'bg-action-primary text-text-inverse'
              : `
                text-text-muted
                hover:text-text-primary
              `
          }
        `}
      >
        <Users className="size-4" />
        By Team
      </button>
      <button
        onClick={() => onChange('feature')}
        className={`
          flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors
          ${
            value === 'feature'
              ? 'bg-action-primary text-text-inverse'
              : `
                text-text-muted
                hover:text-text-primary
              `
          }
        `}
      >
        <Layers className="size-4" />
        By Feature
      </button>
    </div>
  );
}
